import {React , useState , useEffect , useContext} from 'react';
import { GlobalContext } from '../../../src/Context/GlobalState'
import "../../Content/Cards_sty.css"
import { makeStyles} from '@material-ui/core/styles';
import Modal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Fade from '@material-ui/core/Fade';
import axios from 'axios';
import {img_500 , unavailable , unavailableLandscape} from "../../not_found/config";
import Button from '@material-ui/core/Button';
import YouTubeIcon from '@material-ui/icons/YouTube';
import "../../components/Content_modal/Content_modal.css"
import Carosel from "../../../src/Carosel/Carosel"
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import FavoriteOutlinedIcon from '@material-ui/icons/FavoriteOutlined';
import IconButton from '@material-ui/core/IconButton';
import ClearTwoToneIcon from '@material-ui/icons/ClearTwoTone';

const useStyles = makeStyles((theme) => ({
  modal: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  paper: {
    width: '90%',
    height: '80%',
    backgroundColor: '#282c34',
    border: '2px solid #2823c4',
    borderRadius : '10px',
    color:"white",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(1, 1, 3),
  },
}));

export default function Content_modal({children ,  media_type , id}) {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [content, setContent] = useState();
  const [video, setVideo] = useState()
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const fetchdata = async ()=>{
    const { data } = await axios.get(`https://api.themoviedb.org/3/${media_type}/${id}?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`);
    setContent(data);
  }
  const fetchvideo = async ()=>{
    const { data } = await axios.get(`https://api.themoviedb.org/3/${media_type}/${id}/videos?api_key=${process.env.REACT_APP_API_KEY}&language=en-US`);
    setVideo(data.results[0]?.key);
  } 
  useEffect(() => {
   fetchdata();
   fetchvideo();
   // eslint-disable-next-line
  }, [])

  const {removefromfav , addmoviestofav , fav_movies} = useContext(GlobalContext);
  let serchedmovie = fav_movies.find(o => o.id === id);
  const fav_disabled = serchedmovie?true:false;
  return (
    <>
      <div
      className = "Media" 
      style = {{cursor:'pointer'}}
      color = "inherit"
      onClick={handleOpen}>
        {children}
      </div>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        className={classes.modal}
        open={open}
        onClose={handleClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
        timeout: 500,
        }}
      >
         <Fade in={open}>
          {content && (
            <div className={classes.paper}>
              <div className="ContentModal">
                <img
                  src={
                    content.poster_path
                      ? `${img_500}/${content.poster_path}`
                      : unavailable
                  }
                  alt={content.name || content.title}
                  className="ContentModal__portrait"
                />
                <img
                  src={
                    content.backdrop_path
                      ? `${img_500}/${content.backdrop_path}`
                      : unavailableLandscape
                  }
                  alt={content.name || content.title}
                  className="ContentModal__landscape"
                />
              <div className = "ContentModal_about">
                <span className  = "ContentModal_title">
                    {content.name||content.title} (
                      {(
                        content.first_air_date||content.release_date||"-----"
                      ).substring(0,4)}
                    )
                    <IconButton aria-label="add to favorites"
                    disabled = {fav_disabled}
                    onClick = {()=>addmoviestofav(content)}
                    >
                      {fav_disabled?<FavoriteOutlinedIcon color = "secondary"/>:<FavoriteBorderOutlinedIcon color = "secondary"/>}
                        
                      </IconButton>
                      <IconButton aria-label="remove from favorites"
                    onClick = {()=>removefromfav(id)}
                    >
                      <ClearTwoToneIcon color = "secondary"/>  
                      </IconButton>
                </span>
                {
                  content.tagline&&(<i className = "tagline">{content.tagline}</i>)
                }
                <span className = "ContentModal_description">{content.overview}</span>
                <div>
                <Carosel  id = {id} media_type = {media_type}/></div>
                <Button
                  variant = "contained"
                  startIcon = {<YouTubeIcon />}
                  color = "secondary"
                  target = "__blank"
                  href = {`https://www.youtube.com/watch?v=${video}`}
                >
                  WATCH TRAILER
                </Button>
              </div> 
            </div>
            </div>
          )} 

        </Fade>
      </Modal>
    </>
  );
}
